import { Tooltip } from '@mui/material'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { useEffect, useMemo, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import { HighlightTitle } from './HighlightTitle'
import { Highlight } from './HighlightTypes'

type Props = {
  children: React.ReactElement
  bomItemPointer: BomItemPointer
  featureIndex: number
  open?: boolean
  setOpen?: (open: boolean) => void
  enableHoverListener?: boolean
} & Highlight

const useStyles = makeStyles({ name: 'highlightTooltip' })((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.getContrastText(theme.palette.background.paper),
    border: `1px solid ${theme.palette.divider}`,
    // border: `0px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    // padding: theme.spacing(1),
  },
}))

export const HighlightTooltip = (props: Props) => {
  const [open, setOpen] = useState(props.open || false)
  const { classes } = useStyles()

  const { children, ...highlight } = props

  useEffect(() => {
    setOpen(props.open || false)
  }, [props.open])

  const HighlightTitleComponent = useMemo(() => {
    return (
      <HighlightTitle
        highlight={highlight}
        pdfFeature={props.pdfFeature}
        pdfPage={props.pdfPage}
        featureIndex={props.featureIndex}
        isActiveCheckListFeature={props.isActiveCheckListFeature}
        isCheckListFeature={props.isCheckListFeature}
        isDoneCheckListFeature={props.isDoneCheckListFeature}
        bomItemPointer={props.bomItemPointer}
      />
    )
  }, [
    highlight,
    props.bomItemPointer,
    props.featureIndex,
    props.isActiveCheckListFeature,
    props.isCheckListFeature,
    props.isDoneCheckListFeature,
    props.pdfFeature,
    props.pdfPage,
  ])

  return (
    <Tooltip
      open={open}
      onClose={() => (props.setOpen ? props.setOpen(false) : setOpen(false))}
      onOpen={() => (props.setOpen ? props.setOpen(true) : setOpen(true))}
      title={HighlightTitleComponent ?? ''}
      disableHoverListener={props.enableHoverListener ? false : !open}
      onContextMenu={(e) => {
        e.preventDefault()
        props.setOpen ? props.setOpen(true) : setOpen(true)
      }}
      // placement={!props.isCheckListFeature ? 'left' : 'top'}
      placement={'left'}
      // placement={
      //   (['left', 'top', 'bottom', 'right'].at(
      //     Math.floor(Math.random() * 4),
      //   ) as PopperPlacementType) || 'top'
      // }
      disableInteractive={!props.isCheckListFeature}
      arrow
      classes={{
        tooltip: classes.tooltip,
      }}
    >
      {props.children}
    </Tooltip>
  )
}
